import React from 'react';
import { useUserStore } from 'stores';
import Login from 'components/AuthScreens/Login';
import { SparkDialog } from 'sharedComponents/UI';
import Register from 'components/AuthScreens/Register';
import ForgetPassword from 'components/AuthScreens/ForgetPassword';
import AddWorkspaceDialogContent from 'components/Dashboard/Modals/AddWorkspaceDialogContent';
import { Box } from '@mui/material';

type Props = { open: boolean; onClose: () => void; callBack: () => void };

export default function AuthenticationModal({
  open,
  onClose,
  callBack,
}: Props) {
  const userID = useUserStore(
    React.useCallback((state) => state.currentUserID, [])
  );

  const [view, setView] = React.useState<
    'sign up' | 'register' | 'forgot password' | 'onBoarding'
  >(userID ? 'onBoarding' : 'register');

  const handleCallback = () => {
    if (view !== 'register') {
      callBack();
      return;
    }
    setView('onBoarding');
  };

  return (
    <SparkDialog
      open={open}
      onClose={onClose}
      title=''
      dialogContentStyles={{
        '&.MuiDialogContent-root': {
          display: 'flex',
          justifyContent: 'center',
        },
      }}
      sx={{
        '& .MuiPaper-root': {
          maxHeight: 'unset',
        },
      }}
      hideTitle={true}
    >
      {view === 'sign up' && (
        <Box width='100%' maxWidth='600px'>
          <Login
            callBack={handleCallback}
            modalView={true}
            onCreateAccountClick={() => setView('register')}
            onForgetPasswordClick={() => setView('forgot password')}
          />
        </Box>
      )}
      {view === 'register' && (
        <Box width='100%' maxWidth='600px'>
          <Register
            modalView={true}
            onSigIinClick={() => setView('sign up')}
            callBack={handleCallback}
          />
        </Box>
      )}
      {view === 'forgot password' && (
        <Box width='100%' maxWidth='600px'>
          <ForgetPassword
            modalView={true}
            onSigIinClick={() => setView('sign up')}
          />
        </Box>
      )}
      {view === 'onBoarding' && (
        <AddWorkspaceDialogContent
          callBack={handleCallback}
          renderWelcomeText={true}
        />
      )}
    </SparkDialog>
  );
}
